import React, { useState } from 'react';
import { useInView } from './useParallax';
import { DiamondDivider, OmGlyph } from './svgs';
import './Contact.css';

export default function Contact() {
  const [ref, inView] = useInView(0.1);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    // Compose a mailto link with form data
    const subject = encodeURIComponent(`Message from ${form.name} — Vedanagari`);
    const body = encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:info@vedanagari.org?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <section className="contact" id="contact" ref={ref}>
      <div className="section-container">
        <div className={`contact__header ${inView ? 'contact__header--visible' : ''}`}>
          <OmGlyph size={48} color="#FF6B00" />
          <p className="contact__eyebrow cinzel">Reach Out</p>
          <h2 className="contact__title cinzel">
            Visit the <span className="contact__title-accent">Ashram</span>
          </h2>
          <DiamondDivider color="#FF6B00" />
          <p className="contact__intro">
            Vedanagari is open to all. Whether you seek a meal, a blessing, a longer stay, or
            simply to help with seva — you are welcome here.
          </p>
        </div>

        <div className={`contact__grid ${inView ? 'contact__grid--visible' : ''}`}>
          {/* Info panel */}
          <div className="contact__info">
            <div className="contact__info-item">
              <span className="contact__info-icon">📍</span>
              <div>
                <h4 className="cinzel">Location</h4>
                <p>Vedanagari Ashram<br />Tiruvannamalai, Tamil Nadu<br />India — at the foot of Arunachala</p>
              </div>
            </div>

            <div className="contact__info-item">
              <span className="contact__info-icon">📞</span>
              <div>
                <h4 className="cinzel">Phone</h4>
                <p>
                  <a href="tel:+919611701326">+91 96117 01326</a><br />
                  <a href="tel:+919741543700">+91 97415 43700</a>
                </p>
              </div>
            </div>

            <div className="contact__info-item">
              <span className="contact__info-icon">✉️</span>
              <div>
                <h4 className="cinzel">Email</h4>
                <p><a href="mailto:info@vedanagari.org">info@vedanagari.org</a></p>
              </div>
            </div>

            <div className="contact__info-item">
              <span className="contact__info-icon">🕉️</span>
              <div>
                <h4 className="cinzel">Darshan Hours</h4>
                <p>Open daily · Prasadam 24/7<br />Puja timings: dawn &amp; dusk</p>
              </div>
            </div>

            <div className="contact__support">
              <h4 className="cinzel">Support Our Seva</h4>
              <p>
                Your donation enables us to feed pilgrims, conduct homams, and care for sadhus.
                Every contribution, however small, is an act of worship.
              </p>
              <a href="mailto:info@vedanagari.org?subject=Donation%20Enquiry" className="contact__donate-btn cinzel">
                Support Us
              </a>
            </div>
          </div>

          {/* Contact form */}
          <div className="contact__form-wrap">
            {sent ? (
              <div className="contact__thankyou">
                <OmGlyph size={64} color="#F5C842" />
                <h3 className="cinzel">Namaste 🙏</h3>
                <p>Your message has been composed. Please send it from your email client.</p>
              </div>
            ) : (
              <form className="contact__form" onSubmit={handleSubmit}>
                <h3 className="contact__form-title cinzel">Send a Message</h3>

                <div className="contact__field">
                  <label htmlFor="name" className="cinzel">Your Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={form.name}
                    onChange={handleChange}
                    required
                    placeholder="e.g. Ramesh Kumar"
                  />
                </div>

                <div className="contact__field">
                  <label htmlFor="email" className="cinzel">Email Address</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    placeholder="you@example.com"
                  />
                </div>

                <div className="contact__field">
                  <label htmlFor="message" className="cinzel">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    value={form.message}
                    onChange={handleChange}
                    required
                    placeholder="How can we help you? / How would you like to help us?"
                  />
                </div>

                <button type="submit" className="contact__submit cinzel">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
